import { render } from "./TopPanel.vue?vue&type=template&id=4bdf0894"
import script from "./TopPanel.vue?vue&type=script&lang=ts"
export * from "./TopPanel.vue?vue&type=script&lang=ts"

import "./TopPanel.vue?vue&type=style&index=0&id=4bdf0894&lang=scss"
script.render = render

export default script